import FormError from "./components/error";
import FormBase from "./form";
import FormControl from "./formControl";

export type * from "./types";
export { getFieldArrayValidationNames } from "./utils";

const Form = Object.assign(FormBase, {
  Control: FormControl,
  Error: FormError,
});

export default Form;
